import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Solution() {
  return <section className="py-24 bg-dark-900 relative" data-id="element-176">
      <div className="container mx-auto px-4" data-id="element-177">
        <div className="max-w-5xl mx-auto text-center mb-16" data-id="element-178">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-6xl font-oswald font-bold text-white mb-6" data-id="element-179">
            ELIMINÁ EL{' '}
            <span className="text-neon-cyan text-shadow-neon" data-id="element-180">
              CUELLO DE BOTELLA
            </span>
          </motion.h2>
          <p className="text-xl text-gray-400 font-inter" data-id="element-181">
            Tu fuerza total es igual a la fuerza de tu eslabón más débil.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12 max-w-5xl mx-auto" data-id="element-182">
          {/* Before */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full md:w-2/5 bg-dark-800 p-8 rounded-2xl border border-dark-700 text-center opacity-80" data-id="element-183">
            <div className="text-neon-red font-oswald font-bold text-2xl mb-4 tracking-wider" data-id="element-184">
              ANTES
            </div>
            <div className="w-32 h-32 mx-auto rounded-full border-4 border-neon-red/30 flex items-center justify-center mb-6 relative" data-id="element-185">
              <div className="absolute inset-0 bg-neon-red/10 rounded-full animate-pulse" data-id="element-186"></div>
              <span className="text-4xl font-bold text-white" data-id="element-187">40%</span>
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-188">
              FUERZA DESAPROVECHADA
            </h3>
            <p className="text-gray-400 text-sm" data-id="element-189">
              El sistema nervioso inhibe la fuerza de tus músculos grandes
              porque tus manos no pueden sostener la carga.
            </p>
          </motion.div>

          {/* Arrow */}
          <motion.div initial={{
          opacity: 0,
          scale: 0
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="hidden md:flex w-16 h-16 bg-dark-800 rounded-full items-center justify-center border border-dark-700 z-10" data-id="element-190">
            <ArrowRight className="w-8 h-8 text-neon-cyan" data-id="element-191" />
          </motion.div>

          {/* After */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full md:w-2/5 bg-dark-800 p-8 rounded-2xl border border-neon-cyan shadow-neon-cyan text-center relative overflow-hidden" data-id="element-192">
            <div className="absolute inset-0 bg-neon-cyan/5" data-id="element-193"></div>
            <div className="text-neon-cyan font-oswald font-bold text-2xl mb-4 tracking-wider text-shadow-neon relative z-10" data-id="element-194">
              DESPUÉS
            </div>
            <div className="w-32 h-32 mx-auto rounded-full border-4 border-neon-cyan flex items-center justify-center mb-6 relative z-10 shadow-neon-cyan-inner" data-id="element-195">
              <span className="text-4xl font-bold text-white text-shadow-neon" data-id="element-196">
                100%
              </span>
            </div>
            <h3 className="text-xl font-bold text-white mb-2 relative z-10" data-id="element-197">
              FUERZA APLICADA
            </h3>
            <p className="text-gray-300 text-sm relative z-10" data-id="element-198">
              Transferencia total. Tu agarre soporta la carga, permitiendo que
              tus músculos principales trabajen al máximo.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}